import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Heart } from 'react-feather';
import Skeleton from 'react-loading-skeleton';

import { colors } from '../../../styles/settings';
import { waitPromise } from '../../../utils/promiseHelpers';

import { FeaturesState } from 'common/features/featuresReducer';
import {
    favoriteBrandThunk,
    getFavoritesThunk,
    unfavoriteBrandThunk,
} from 'common/features/store/duck/brands/duck';
import { createStyle, createStyles } from 'utils/createStyle';

export interface BrandFavoriteProps {
    brandId: string;
    brandName: string;
}

export interface HeartIconProps
    extends React.DetailedHTMLProps<
        React.ButtonHTMLAttributes<HTMLButtonElement>,
        HTMLButtonElement
    > {
    isActive: boolean;
    title?: string;
    ariaLabel?: string;
    size?: number;
}

const styles = createStyles({
    animationPulsingHeart: createStyle('', {
        animation: 'heartbeat 2s infinite',
    }),
});

export const BrandFavorite = ({ brandId, brandName }: BrandFavoriteProps) => {
    const brands = useSelector((state: FeaturesState) => state.store.brands);
    const isFavorite = brands && brands.favorites.indexOf(brandId) > -1;
    const [isSaving, setIsSaving] = useState(false);
    const dispatch = useDispatch<any>();

    const toggle = () => {
        if (!isFavorite) {
            waitPromise(favoriteBrandThunk(brandId)(dispatch), setIsSaving);
        } else {
            waitPromise(unfavoriteBrandThunk(brandId)(dispatch), setIsSaving);
        }
    };

    return (
        <div className="mt-auto inline-block">
            <div className="inline-block relative">
                <button
                    className="favorites_icon"
                    aria-label={
                        isFavorite
                            ? `Remove ${brandName} from favorites`
                            : `Add ${brandName} to favorites`
                    }
                    title={
                        isFavorite
                            ? `Remove ${brandName} from favorites`
                            : `Add ${brandName} to favorites`
                    }
                    onClick={toggle}
                    style={{ visibility: 'visible', outline: 'none' }}
                >
                    <Heart
                        fill={isFavorite ? colors.brandAccent : 'white'}
                        width={22}
                        className={`text-brand-accent inline-block ${
                            isSaving ? styles.animationPulsingHeart : ''
                        }`}
                    />
                </button>
            </div>
        </div>
    );
};
